var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 5.16683C6.99967 4.79864 6.7012 4.50016 6.33301 4.50016C5.96482 4.50016 5.66634 4.79864 5.66634 5.16683V8.50016C5.66634 8.86835 5.96482 9.16683 6.33301 9.16683H8.33301C8.7012 9.16683 8.99967 8.86835 8.99967 8.50016C8.99967 8.13197 8.7012 7.8335 8.33301 7.8335H6.99967V5.16683Z",
    fill: "#344054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99967 0.833496C3.31778 0.833496 0.333008 3.81826 0.333008 7.50016C0.333008 11.1821 3.31778 14.1668 6.99967 14.1668C10.6816 14.1668 13.6663 11.1821 13.6663 7.50016C13.6663 3.81826 10.6816 0.833496 6.99967 0.833496ZM1.66634 7.50016C1.66634 4.55464 4.05416 2.16683 6.99967 2.16683C9.94519 2.16683 12.333 4.55464 12.333 7.50016C12.333 10.4457 9.94519 12.8335 6.99967 12.8335C4.05416 12.8335 1.66634 10.4457 1.66634 7.50016Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e2d7124c9b8f70d328b0ccf3dfd276e2.svg";
export { ForwardRef as ReactComponent };